import React, { useEffect, createContext } from 'react';
import useModal from '../hooks/useModal.js';

const ModalContext = createContext();
export default ModalContext;

const { Provider } = ModalContext;
export const ModalProvider = ({ children }) => {
    const { modalActive, setModalActive } = useModal();

    useEffect(() => {
        document.body.addEventListener("keydown", (event) => {
            if(event.key === "Escape") {
                setModalActive(false);
            }
        });
    }, []);

    return (
        <Provider value={{ modalActive, setModalActive }}>
            {children}
        </Provider>
    );
};
